import type { Reducer } from 'redux';

import { HYDRATE } from '@/core/applicationState/store/hydrateAction';
import { GRAPHQL_SUCCESS } from '@/productDiscovery/ProductPage/detail.actions';

import type { BulkPurchaseState } from '../interfaces/BulkPurchase.model';
import {
  GET_BULK_PURCHASE_FAILURE,
  GET_BULK_PURCHASE_SUCCESS,
  type BulkPurchaseAction,
} from './BulkPurchase.actions';
import { bulkPurchaseInitialState } from './BulkPurchase.initialState';

export const bulkPurchaseReducer: Reducer<
  BulkPurchaseState,
  BulkPurchaseAction
> = (state = bulkPurchaseInitialState, action) => {
  switch (action.type) {
    case GET_BULK_PURCHASE_SUCCESS:
      return {
        ...state,
        data: action.payload.data,
      };

    case GET_BULK_PURCHASE_FAILURE:
      return {
        ...state,
        error: action.payload?.error,
      };

    case GRAPHQL_SUCCESS: {
      if (!action.payload?.bulkDiscount?.thresholds?.length)
        return bulkPurchaseInitialState;

      const { productId, thresholds = [] } = action.payload.bulkDiscount;

      return {
        data: [
          {
            productId,
            thresholds: thresholds
              .filter((threshold) => !!threshold)
              .map(({ minUnits, maxUnits, percentage }) => ({
                minUnits,
                maxUnits,
                percent: percentage,
              })),
          },
        ],
      };
    }

    case HYDRATE:
      return (
        action.state.productDiscovery?.bulkPurchase ?? bulkPurchaseInitialState
      );

    default:
      return state;
  }
};
